<section class="tours-height">
  <div class="align-items-end bg-hero d-flex h-100 position-relative">
    <div class="container">
      <div class="row" style="display: flex; justify-content: center;">
        <div class="col-md-6">
          <form action="" class="login pass mb-4">
            <div class="form-control" >
              <p class="mb-1 text-white">Destino o tour</p>
              <input type="text" name="destino" class="w-100" [(ngModel)]="destino">
            </div>
            <div class="form-control">
              <!-- <p class="mb-1 text-white">Mes</p>
                            <input type="password" name="" class="w-100"> -->
              <p class="mb-1 text-white">Mes</p>
              <select [(ngModel)]="fecha" name="fecha" id="fecha" class="documento w-100"
                style="background-color: white; border: none;">
                <option value="" selected></option>
                <option value="enero">Enero</option>
                <option value="febrero">Febrero</option>
                <option value="marzo">Marzo</option>
                <option value="abril">Abril</option>
                <option value="mayo">Mayo</option>
                <option value="junio">Junio</option>
                <option value="julio">Julio</option>
                <option value="agosto">Agosto</option>
                <option value="septiembre">Septiembre</option>
                <option value="octubre">Octubre</option>
                <option value="noviembre">Noviembre</option>
                <option value="diciembre">Diciembre</option>
              </select>
            </div>
            <div class="form-control text-center mt-4">
              <button style="cursor: pointer;"  (click)="getToursByAgent(destino, fecha, ordenarPor)"
                class="align-self-center border-2 btn btn-lg btn-secondary btn-reservar rounded-pill text-center">Buscar</button>
            </div>
          </form>

        </div>
      </div>
    </div>
  </div>
</section>

<section class="tours-home" style="padding: 57px; margin-top: -50px;">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 d-flex justify-content-between flex-lg-row flex-column pt-5 pb-5">
        <h4 class="title-bg">{{cantidadTours}} resultados encontrados</h4>
        <select name="orderBy" [(ngModel)]="ordenarPor" class="filtro-tours" id="orderBy"
          (change)="getToursByAgent(destino, fecha, ordenarPor)">
          <option value="destino" selected>Ordenar por destino</option>
          <option value="fecha">Ordenar por fecha</option>
        </select>
      </div>
    </div>
    <div class="row" >
      <div class="space" *ngIf="!listTours.length" >      
      </div>
       <div class="tour-card" *ngFor="let item of listTours" >
        <div class="tour-wrapper">
          <div class="tour-img"><img src="{{item.imagen? item.imagen : imagenDefault}}" class="img-responsive img-fluid" alt=""></div>
          <div class="tour-destino">
            <h5 class="mb-0">{{item.paquete.nombre_paquete}}</h5>
          </div>
          <div class="tour-content">
            <p class="pb-3">{{item.paquete.descripcion}}</p>
            <div class="d-flex align-items-center flex-row mb-3">
              <img src="assets/images/body/icons/calendario.svg" alt="">
              <p class="mb-0 ps-2">Salida: {{item.paquete.fecha  | date: 'dd/MM/yyyy'}}</p>
            </div>
            <div class="d-flex align-items-center flex-row mb-4">
              <img src="assets/images/body/icons/cama.svg" alt="">
              <p class="mb-0 ps-2">{{item.paquete.cantidad_noches}} Noches</p>
            </div>
            <a  [routerLink]="['/','tours', 'reservation' ,item.paquete.id]"
              class="btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center">Reservar</a>
          </div>
        </div>
      </div>

      <!-- *** tarjeta no visible para evitar descuadre de responsive ne caso de resultados encontrados = 0 -->
       <!--<div class="tour-card" style="visibility: hidden;" >
        <div class="tour-wrapper">
          <div class="tour-img"><img src="{{imagenDefault}}" class="img-responsive img-fluid" alt=""></div>
          <div class="tour-destino">
            <h5 class="mb-0">nombre</h5>
          </div>
          <div class="tour-content">
            <p class="pb-3">test</p>
            <div class="d-flex align-items-center flex-row mb-3">
              <img src="assets/images/body/icons/calendario.svg" alt="">
              <p class="mb-0 ps-2">Salida: </p>
            </div>
            <div class="d-flex align-items-center flex-row mb-4">
              <img src="assets/images/body/icons/cama.svg" alt="">
              <p class="mb-0 ps-2">2 Noches</p>
            </div>
            <a  
              class="btn btn-lg rounded-pill btn-primary text-white text-center btn-reservar align-self-center">Reservar</a>
          </div>
        </div>
      </div>-->
      <!-- *** fin de tarjeta no visible para evitar descuadre de responsive ne caso de resultados encontrados = 0 -->

    </div>
  </div>
</section>
<section class="bg-home bg-tours">
  <div class="container pb-5 pt-5">
    <div class="row">
      <div class="col-12 text-center">

      </div>
    </div>
  </div>
</section>
